<template>
  <layout-main-inner title="优惠券">
    <el-button
      slot="action"
      type="primary"
      @click="addLottery">新增优惠券</el-button>
    <layout-card-wrap hasHeaderSlot>
      <el-form
        slot="form"
        :inline="true"
        class="margin-botton-0"
        @submit.native.prevent>
        <el-form-item>
          <el-radio-group
            v-model="config.scope"
            style="vertical-align: top;"
            @change="handleCurrentChange(1)">
            <el-radio-button :label="null">全部</el-radio-button>
            <el-radio-button :label="0">单品</el-radio-button>
            <el-radio-button :label="1">全场</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-radio-group
            v-model="config.isopen"
            style="vertical-align: top;"
            @change="handleCurrentChange(1)">
            <el-radio-button :label="1">可用</el-radio-button>
            <el-radio-button :label="0">不可用</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="config.couponName"
            placeholder="请输入优惠劵名称"
            clearable=""
            @clear="handleCurrentChange(1)">
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleCurrentChange(1)"></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column
          label="优惠劵名称"
          prop="couponName"></el-table-column>
        <el-table-column label="优惠额">
          <template slot-scope="{row}">
            <span v-if="row.couponType === 1">满{{ row.fullMoney }}元减{{ row.money }}元</span>
            <span v-if="row.couponType === 2">{{ row.money }}折</span>
            <span v-if="row.couponType === 5">每满{{ row.fullMoney }}元减{{ row.money }}元</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="类型"
          width="70">
          <template slot-scope="{row}">
            <el-tag
              v-if="row.scope === 1"
              type="info">全场</el-tag>
            <el-tag
              v-if="row.scope === 0"
              type="success">单品</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column
          label="适用商品"
          width="100">
          <template slot-scope="{row}">
            <div v-if="row.scope === 1">全场通用</div>
            <div
              v-for="(item,index) in row.products"
              v-else
              :key="index"
              class="overflow-hidden"
              :title="item.goodsName">{{ item.goodsName }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="适用会员"
          width="70">
          <template slot-scope="{row}">
            <div v-if="row.userLevel === 0">新人</div>
            <div v-else>会员</div>
          </template>
        </el-table-column>
        <el-table-column
          label="发券时间"
          width="170">
          <template slot-scope="{row}">
            {{ row.receiveBeginTime | dateformat('YYYY/MM/DD') }} - {{ row.receiveEndTime | dateformat('YYYY/MM/DD') }}
          </template>
        </el-table-column>
        <el-table-column
          label="使用时间"
          width="170">
          <template slot-scope="{row}">
            <div v-if="row.validTimeType === 1">
              {{ row.beginTime | dateformat('YYYY/MM/DD') }} - {{ row.endTime | dateformat('YYYY/MM/DD') }}
            </div>
            <div v-else>
              自领取后{{ row.effectiveDays }}天
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="限领1张"
          width="70">
          <template slot-scope="{row}">{{ row.receiveLimit === 1 ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="70">
          <template slot-scope="{row}">
            <el-tag
              v-if="row.isopen === 1"
              type="success">可用</el-tag>
            <el-tag
              v-else
              type="danger">不可用</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="剩余/库存"
          width="160">
          <template slot-scope="{row}">{{ row.remainCount }} / {{ row.totalCount }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="160">
          <template slot-scope="{row}">
            <el-button
              type="primary"
              @click="getcouponnumbers(row)">劵码</el-button>
            <el-dropdown>
              <el-button
                type="info"
                style="margin-left: 10px">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="updateStorage(row)">调整库存</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.isopen === 1"
                  @click.native="disenablecoupon(row)">关闭</el-dropdown-item>
                <el-dropdown-item
                  v-else
                  @click.native="enablecoupon(row)">启用</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
      <coupon-reg-modal
        ref="modal"
        :callback="fetchList" />
      <coupon-num-modal ref="list" />
      <coupon-storage-modal
        ref="storage"
        :callback="fetchList" />
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import CouponRegModal from '../busi/coupon-reg-modal.vue'
import CouponNumModal from '../busi/coupon-num-modal.vue'
import CouponStorageModal from '../busi/coupon-storage-modal.vue'
// import moment from 'moment'
export default {
  name: 'CouponList',
  components: { CouponRegModal, CouponNumModal, CouponStorageModal },
  data() {
    return {
      loading: true,
      pickerOptions: {
        disabledDate: (date) => {
          console.log(date)
          return false
          // return date <= Date.now()
        }
      },
      list: [],
      total: 0,
      config: {
        couponName: '',
        scope: null,
        isopen: 1,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    addLottery() {
      this.$refs.modal.add(this.userInfo.orgId)
    },
    updateStorage(row) {
      this.$refs.storage.update({
        ...row
      })
    },
    enablecoupon(row) {
      this.$confirm('您确定启用该优惠券吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('coupon/enablecoupon', {
            payload: {
              vendorId: row.vendorId,
              couponId: row.couponId
            },
            success: () => {
              this.loading = false
              this.handleCurrentChange(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    disenablecoupon(row) {
      this.$confirm('您确定关闭该优惠券吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('coupon/disenablecoupon', {
            payload: {
              vendorId: row.vendorId,
              couponId: row.couponId
            },
            success: () => {
              this.loading = false
              this.handleCurrentChange(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('coupon/getcoupons', {
        payload: {
          ...this.config,
          vendorId: this.userInfo.vendorId
        },
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            // i.endTime = i.endTime - 1
            i.remainCount = i.totalCount - i.receivedCount - i.invalidCount
            return i
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getcouponnumbers(row) {
      this.$refs.list.fetch(row)
    }
  }
}
</script>
<style lang="stylus" scoped>
.overflow-hidden {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
